import { IconCash } from '@tabler/icons-react';

import { TimeSeriesChart } from '@charts';

export default function RevenueChart({ report, reportLoading }) {
    return (
        <TimeSeriesChart
            title="Receita no período"
            icon={<IconCash size={15} />}
            timeSeries={report?.revenue}
            valueType="money"
            report={report}
            reportLoading={reportLoading}
        />
    );
}
